import styled from 'styled-components'

export const ContentAreaSkeleton = styled.div`
  flex-grow: 1;
  padding: 40px;
  display: flex;
  justify-content: center;
`
